"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
exports.IsCurrencyAvailable = void 0;
var class_validator_1 = require("class-validator");
var constants_1 = require("../constants");
var IsCurrencyAvailable = (function () {
    function IsCurrencyAvailable() {
    }
    IsCurrencyAvailable.prototype.validate = function (cur) {
        if (Array.isArray(cur)) {
            if (cur.length < 1 || cur.some(function (c) { return !constants_1.CURRENCY_CODES.includes(c); }))
                return false;
        }
        else if (!constants_1.CURRENCY_CODES.includes(cur))
            return false;
        return true;
    };
    IsCurrencyAvailable = __decorate([
        class_validator_1.ValidatorConstraint({ name: 'IsCurrencyAvailable', async: false })
    ], IsCurrencyAvailable);
    return IsCurrencyAvailable;
}());
exports.IsCurrencyAvailable = IsCurrencyAvailable;
//# sourceMappingURL=validate-currency.dto.js.map